import React from "react";
import { ButtonSC, ButtonText, DotSC, DotsSC, PaginationSC } from "./styled";

interface PaginationProps {
    totalPages: number;
    currentPage: number;
    onPageChange: (val: number) => void;
}

const dots = [1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => <DotSC key={index} />);

export const Pagination = ({
    totalPages,
    currentPage,
    onPageChange,
}: PaginationProps) => {
    const handlePageClick = (page: number) => {
        onPageChange(page);
    };

    const renderPageNumbers = () => {
        const pages = [];
        const showEllipsis = totalPages > 7; // Показываем многоточие, если страниц больше 7

        if (!showEllipsis) {
            // Если страниц немного, показываем все
            for (let i = 1; i <= totalPages; i++) {
                pages.push(
                    <ButtonSC
                        key={i}
                        onClick={() => handlePageClick(i)}
                        isActive={i === currentPage}
                    >
                        <ButtonText>{i}</ButtonText>
                    </ButtonSC>,
                );
            }
            return pages;
        }

        // Показываем первую страницу
        pages.push(
            <ButtonSC
                key={1}
                onClick={() => handlePageClick(1)}
                isActive={1 === currentPage}
            >
                <ButtonText>1</ButtonText>
            </ButtonSC>,
        );

        // Показываем многоточие, если текущая страница далека от начала
        if (currentPage > 4) {
            pages.push(<DotsSC key="ellipsis-start2">{dots}</DotsSC>);
        }

        // Показываем несколько страниц вокруг текущей
        const startPage = Math.max(2, currentPage - 2);
        const endPage = Math.min(totalPages - 1, currentPage + 2);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <ButtonSC
                    key={i}
                    onClick={() => handlePageClick(i)}
                    isActive={i === currentPage}
                >
                    <ButtonText>{i}</ButtonText>
                </ButtonSC>,
            );
        }

        // Показываем многоточие, если текущая страница далека от конца
        if (currentPage < totalPages - 3) {
            pages.push(<DotsSC key="ellipsis-start">{dots}</DotsSC>);
        }

        // Показываем последнюю страницу
        pages.push(
            <ButtonSC
                key={totalPages}
                onClick={() => handlePageClick(totalPages)}
                isActive={totalPages === currentPage}
            >
                <ButtonText>{totalPages}</ButtonText>
            </ButtonSC>,
        );

        return pages;
    };

    return <PaginationSC>{renderPageNumbers()}</PaginationSC>;
};

export default Pagination;
